'use client';

import {
  GridItem,
  LayoutGrid,
  TypographyRhythm,
  TypographyV3,
} from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import TCSection from '../_components/TCSection';
import type { TCData, TCSectionData } from '../_components/types';

const TCContent = (data: TCData) => {
  const t = useTranslations();

  return (
    <section>
      <LayoutGrid>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <TypographyRhythm>
            <TypographyV3
              Element="h1"
              variant="h3"
              className="m-0 text-center lg:px-14 lg:pb-9"
            >
              {t(data.title)}
            </TypographyV3>
            {data.sectionData.map((props: TCSectionData) => (
              <TCSection key={props.id} {...props} />
            ))}
          </TypographyRhythm>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default TCContent;
